// todo: Данил, наверно это не надо

document.addEventListener('DOMContentLoaded', () => {
  document.initChangeCountAdditionalKeys = () => {
    const modal = $('#modalAddKeys');

    modal.on('click', '.change-count-additional-keys', () => {
      const count = modal.find('input#modalAddKeysQuantity').val();

      if (!document.querySelector('[data-in-cart="true"]')) {
        setLabelAdditionalKeys(count);
        return;
      }

      const data = {
        productId: modal.data('product-id'),
        serviceId: modal.data('service-id'),
        count,
      };

      window.promiseQueue.add('change-cart', () => {
        $.ajax({
          method: 'POST',
          url: window.CART_ADD_SERVICE_URI,
          data,
          cache: false,
        })
          .done((response) => {
            setLabelAdditionalKeys(response.count);
          })
          .fail(() => {
            document.modalMessageErrorShow();
          });
      });
    });
  };

  showOrHideLabelAdditionalKeys();
  document.initChangeCountAdditionalKeys();
});

const setLabelAdditionalKeys = (count) => {
  const labelAdditionalKeys = $('span.count-additional-keys');
  if (!labelAdditionalKeys) return;

  labelAdditionalKeys.text(` + ${count}`);
  labelAdditionalKeys.data('count', count);
  showOrHideLabelAdditionalKeys();
};

const showOrHideLabelAdditionalKeys = () => {
  const labelAdditionalKeys = $('span.count-additional-keys');
  if (!labelAdditionalKeys) return;
  if (labelAdditionalKeys.data('count') > 0) {
    labelAdditionalKeys.show();
  } else {
    labelAdditionalKeys.hide();
  }
};
